import { render, staticRenderFns } from "./attribute-field-BOOLEAN.vue?vue&type=template&id=7f4d3ff4&"
import script from "./attribute-field-BOOLEAN.vue?vue&type=script&lang=js&"
export * from "./attribute-field-BOOLEAN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4d3ff4')) {
      api.createRecord('7f4d3ff4', component.options)
    } else {
      api.reload('7f4d3ff4', component.options)
    }
    module.hot.accept("./attribute-field-BOOLEAN.vue?vue&type=template&id=7f4d3ff4&", function () {
      api.rerender('7f4d3ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attribute-form-fields/attribute-field-BOOLEAN.vue"
export default component.exports